import { render, staticRenderFns } from "./InvoiceTermsStep.vue?vue&type=template&id=53fb67d0&scoped=true"
import script from "./InvoiceTermsStep.vue?vue&type=script&lang=js"
export * from "./InvoiceTermsStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fb67d0",
  null
  
)

export default component.exports